import { Component, Input, OnInit } from '@angular/core';
import { Photo } from 'src/app/model/installation/photos.model';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss']
})
export class DocumentComponent implements OnInit {

  @Input()
  document!: Photo;
  
  constructor() { }

  ngOnInit(): void {
    
//    {{doc.original_filename}}
  }

}
